/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Selection
 */
export interface Selection {
    /**
     * 
     * @type {string}
     * @memberof Selection
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof Selection
     */
    name: string;
}

/**
 * Check if a given object implements the Selection interface.
 */
export function instanceOfSelection(value: object): value is Selection {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SelectionFromJSON(json: any): Selection {
    return SelectionFromJSONTyped(json, false);
}

export function SelectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Selection {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'name': json['name'],
    };
}

export function SelectionToJSON(json: any): Selection {
    return SelectionToJSONTyped(json, false);
}

export function SelectionToJSONTyped(value?: Selection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'name': value['name'],
    };
}

